if (!customElements.get('xflow-pricing-calculator')) {
  class XFlowPricingCalculator extends HTMLElement {
    constructor() {
      super();
      this._slider = null;
      this._input = null;
      this._cards = [];
      this._customRow = null;
      this._rafId = null;
      this._onSlider = this._onSliderInput.bind(this);
      this._onInput = this._onInputChange.bind(this);
    }

    connectedCallback() {
      this._slider = this.querySelector('.xflow-pricing-calc__slider');
      this._input = this.querySelector('.xflow-pricing-calc__input');
      this._customRow = this.querySelector('.xflow-pricing-calc__custom');
      this._cards = Array.from(this.querySelectorAll('.xflow-pricing-calc__card'));
      if (!this._slider || !this._input) return;

      this._slider.addEventListener('input', this._onSlider);
      this._input.addEventListener('input', this._onInput);

      requestAnimationFrame(function() { this._update(+this._input.value || 0); }.bind(this));
    }

    disconnectedCallback() {
      if (this._slider) this._slider.removeEventListener('input', this._onSlider);
      if (this._input) this._input.removeEventListener('input', this._onInput);
      if (this._rafId) { cancelAnimationFrame(this._rafId); this._rafId = null; }
    }

    _parsePlans() {
      return this._cards.map(function(c) { return {
        id: c.dataset.planId || '',
        name: c.dataset.planName || '',
        base: parseFloat(c.dataset.planBase) || 0,
        included: parseInt(c.dataset.planIncluded, 10) || 0,
        rate: parseFloat(c.dataset.planRate) || 0,
      };});
    }

    _calcFee(p, rev) {
      return p.base + Math.ceil(Math.max(0, rev - p.included) / 1000) * p.rate;
    }

    _calcExtra(p, rev) {
      return Math.ceil(Math.max(0, rev - p.included) / 1000) * p.rate;
    }

    _bestPlan(plans, rev) {
      var best = plans[0], bestFee = this._calcFee(plans[0], rev);
      for (var i = 1; i < plans.length; i++) {
        var f = this._calcFee(plans[i], rev);
        if (f < bestFee) { bestFee = f; best = plans[i]; }
      }
      return best;
    }

    _onSliderInput() {
      var v = +this._slider.value;
      this._input.value = v;
      this._scheduleUpdate(v);
    }

    _onInputChange() {
      var v = Math.min(99999, Math.max(0, +this._input.value || 0));
      this._slider.value = Math.min(v, parseInt(this._slider.max, 10) || 20000);
      this._scheduleUpdate(v);
    }

    _scheduleUpdate(rev) {
      if (this._rafId) cancelAnimationFrame(this._rafId);
      this._rafId = requestAnimationFrame(function() { this._update(rev); this._rafId = null; }.bind(this));
    }

    _update(rev) {
      rev = Math.max(0, rev);
      var plans = this._parsePlans();
      if (!plans.length) return;

      var fees = plans.map(function(p) { return this._calcFee(p, rev); }.bind(this));
      var extras = plans.map(function(p) { return this._calcExtra(p, rev); }.bind(this));
      var rec = this._bestPlan(plans, rev);
      var over15k = rev > 15000;
      var max = parseInt(this._slider.max, 10) || 20000;

      this._slider.style.setProperty('--xflowprice-slider-pct', Math.min((rev / max) * 100, 100) + '%');

      this._cards.forEach(function(card, i) {
        var p = plans[i];
        var amt = card.querySelector('[data-role="usage-amount"]');
        var sub = card.querySelector('[data-role="usage-sub"]');
        var tot = card.querySelector('[data-role="total-amount"]');
        var savBox = card.querySelector('.xflow-pricing-calc__save');
        var savText = savBox ? savBox.querySelector('.xflow-pricing-calc__save-content') : null;

        if (amt) amt.textContent = extras[i] > 0 ? '$' + extras[i] : '$0';
        if (sub) sub.textContent = '$' + p.rate + ' per additional $1,000';
        if (tot) tot.textContent = '$' + fees[i];

        if (savBox) {
          if (i > 0 && fees[i - 1] > fees[i] && fees[i] > 0) {
            var pct = Math.round(((fees[i - 1] - fees[i]) / fees[i - 1]) * 100);
            if (savText) savText.textContent = 'Save ' + pct + '% vs ' + plans[i - 1].name + "'s";
            savBox.classList.add('show');
          } else {
            savBox.classList.remove('show');
          }
        }

        var isRec = !over15k && p.id === rec.id;
        card.classList.toggle('recommended', isRec);

        var tag = card.querySelector('[data-role="tag"]');
        if (tag) tag.hidden = !isRec;
      }.bind(this));

      if (this._customRow) {
        this._customRow.classList.toggle('show', over15k);
        this._customRow.classList.toggle('recommended', over15k);
      }
    }
  }
  customElements.define('xflow-pricing-calculator', XFlowPricingCalculator);
}
